<template>
  <div class="edit" v-loading="loading" element-loading-text="数据获取中">
    <div class="editContent">
      <div class="MQcut">
        <div class="uploadpic" v-if="!!qmData.autoScreenshotMd5">
          <img :src="questionImgListUrl(qmData.autoScreenshotMd5)" alt="截图" />
        </div>
        <div
          v-for="(item, index) in base64List"
          class="uploadpic canEdit"
          :key="index"
          @mouseenter="mouseenter(index)"
          @mouseleave="mouseleave(index)"
        >
          <img :src="item.url" alt="截图" @click="startKss(index, $event)" />
          <div
            class="delete"
            v-if="showDelete && item.hasKss && imageIndex == index"
            @click="deleteImage(index)"
          >
            <i class="el-icon-delete"></i>
          </div>
        </div>
      </div>
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="rules"
        label-position="right"
        label-width="90px"
        size="small"
        class="formStyle"
      >
        <el-form-item label="问题描述:" prop="checkContent">
          <el-input
            v-model="addForm.checkContent"
            type="textarea"
            rows="4"
            maxlength="200"
            show-word-limit
            style="max-height: 490px"
            placeholder="请填写问题描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="审图要点:" class="itemStyle">
          <template #label>
            <div class="labelStyle">
              <span>审图要点:</span>
              <el-button
                class="rcStyle"
                type="primary"
                plain
                size="mini"
                @click="showImgPoint"
                >关联审图要点</el-button
              >
            </div>
          </template>
          <el-input
            style="margin-left: 0"
            type="textarea"
            v-model="addForm.drawingReviewPoints"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="关联文件:" class="associatedFileStyle">
          <template #label>
            <div class="labelStyle">
              <span>关联文件:</span>
              <el-button
                class="rcStyle"
                type="primary"
                plain
                size="mini"
                @click="showAssociatedFile"
                >关联文档目录树</el-button
              >
              <el-button
                class="rcStyle"
                type="primary"
                plain
                size="mini"
                @click="uploadFiles"
                >本地上传</el-button
              >
            </div>
          </template>
          <ul>
            <li v-for="(item, index) in floderData" :key="index">
              <p class="fileNamestyle" :title="item.fileName">
                {{ item.fileName }}
              </p>
              <p style="margin-top: 3px">
                <img
                  :src="down"
                  alt="下载"
                  style="margin-right: 8px"
                  @click="todown(item)"
                />
                <img
                  :src="del"
                  alt="删除"
                  style="margin-right: 5px"
                  @click="todel(index)"
                />
              </p>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="意见类型:" prop="qmTypeId" key="qmTypeId">
          <el-select v-model="addForm.qmTypeId" placeholder="请选择意见类型">
            <el-option
              v-for="item in dicList.checkTypeList"
              :key="item.id"
              :label="item.cnName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="严重等级:"
          prop="problemTypeId"
          key="problemTypeId"
        >
          <el-select
            v-model="addForm.problemTypeId"
            placeholder="请选择严重等级"
          >
            <el-option
              v-for="item in dicList.severityLevelList"
              :key="item.id"
              :label="item.cnName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="阶 段:" v-if="stageNameBoolean">
          <div v-if="stageName" >{{ stageName }}</div>
          <el-select v-else v-model="addForm.stageId" placeholder="请选择阶段" >
            <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name=='阶段').optionalValues" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="专 业:" prop="specId">
          <div v-if="specName">{{ specName }}</div>
          <el-select
            v-else
            v-model="addForm.specId"
            placeholder="请选择专业"
            @change="addForm.multiSpecListspecIds = []"
            filterable
          >
            <el-option
              v-for="item in dicList.specList"
              :key="item.id"
              :label="item.cnName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="专 业:" prop="multiSpecListspecIds">
          <el-select
            v-model="addForm.multiSpecListspecIds"
            placeholder="请选择跨专业"
            multiple
            collapse-tags
            filterable
          >
            <el-option
              v-for="item in multiSpecList"
              :key="item.id"
              :label="item.cnName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item  label="子 项:"  v-if="childNameBoolean">
          <div v-if="childName">{{ childName }}</div>
          <el-select v-else v-model="addForm.stageChildId" placeholder="请选择子项">
            <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name == '子项').optionalValues" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="修改方:">
          <el-select
            v-model="addForm.modifierIds"
            filterable
            placeholder="指定修改人"
            clearable
          >
            <el-option-group
            v-for="group in dicList.modifierList"
            :key="group.label"
            :label="group.label"
            >
              <el-option v-for="item in group.options" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button size="mini" @click="closeModelq(true)">取 消</el-button>
      <el-button
        v-loading="addLoading"
        size="mini"
        title="确认修改"
        type="primary"
        @click="addnotations"
        >修改</el-button
      >
    </div>
    <check-img-point v-if="imgPoint" ref="checkImgPoint" />
    <associated-file v-if="associatedFileShow" ref="associatedFile" />
  </div>
</template>

<script>
const addParamsForm = () => ({
  checkContent: "", //问题描述
  drawingReviewPoints: "", //审图要点
  qmTypeId: "", //意见类型
  problemTypeId: "", //严重等级
  stageId: "", //阶段
  specId: "", //专业
  multiSpecListspecIds: [], //跨专业
  stageChildId: "", //子项
  modifierIds: "", //修改方
});
import { mapState } from "vuex";
import iconImage from "@/CommonDP/assets/notation/icon-cutImg.png";
import notationService from "@/CommonDP/service/file-service";
import question from "@/xgzdService/question-service";
import { questionImgUrl1 } from "@/utils";
import Kscreenshot from "@/utils/kscreenshot/src/kss";
import checkImgPoint from "@/CommonDP/components/checkImgPoint/index.vue";
import { downloadUrltoken } from "@/utils";
import associatedFile from "@/CommonDP/components/associatedFile/index.vue";
export default {
  props: ["questionId", "type"],
  components: { checkImgPoint, associatedFile },
  data() {
    return {
      dicList: [],
      prjID: "",
      fileId: "",
      loading: false,
      qmData: {},
      base64List: [
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false },
      ],
      stageName: "",
      stageNameBoolean: false,
      specName: "",
      specNameBoolean: false,
      multiSpecName: "",
      multiSpecNameBoolean: false,
      childName: "",
      childNameBoolean: false,

      imageIndex: "",
      showDelete: false,
      imgPoint: false,
      addForm: addParamsForm(),
      rules: {
        problemTypeId: [
          { required: true, message: "严重等级不可为空", trigger: "change" },
        ],
        checkContent: [
          { required: true, message: "问题描述不可为空", trigger: "blur" },
        ],
        qmTypeId: [
          { required: true, message: "意见类型不可为空", trigger: "change" },
        ],
        multiSpecListspecIds: [{ required: true, message: "请选择专业", trigger: "change" }],
      },
      addLoading: false,
      picList: [],
      associatedFileShow: false,
      floderData: [],
      down: require("@/CommonDP/assets/issueMgDown.png"),
      del: require("@/CommonDP/assets/issueMgDel.png"),
    };
  },
  computed: {
    ...mapState({
      dwgdata: (state) => state.monge.dwgdata,
      spaceOfDwgData: (state) => state.monge.spaceOfDwgData,
      modeldata: (state) => state.monge.modeldata,
      floderObj: (state) => state.uploaderAnnotation.floderObj,
    }),
    multiSpecList() {
      if (
        this.dicList.specList &&
        this.dicList.specList.length > 0 &&
        this.addForm.specId
      )
        return this.dicList.specList.filter(
          (ele) => ele.id != this.addForm.multiSpecListspecIds
        );
    },
    editParams() {
      const {
        checkContent,
        drawingReviewPoints,
        qmTypeId,
        problemTypeId,
        modifierIds,
        stageId,
        specId,
        multiSpecListspecIds,
        stageChildId,
      } = this.addForm;
      const source = "WEB端";
      const qmType =
        this.dicList.checkTypeList?.find((item) => item.id === qmTypeId)
          .cnName || "";
      const problemType =
        this.dicList.severityLevelList?.find(
          (item) => item.id === problemTypeId
        ).cnName || "";
      let specName =
        this.dicList.specList?.find((item) => item.id === specId).cnName || "";
      let modifierList = []; //修改方改为数组
      let multiSpecList = [];
      if (modifierIds) {
        // let obj = {
        //   modifierId: modifierIds,
        //   modifierName: this.dicList.modifierList.find(
        //     (sor) => sor.userId == modifierIds
        //   ).name,
        // };
        // modifierList.push(obj);
        let list = [...this.dicList.modifierList[0].options, ...this.dicList.modifierList[1].options]
          let selectItem = list.find(sor=>sor.id == modifierIds)
          let obj={modifierId:modifierIds, modifierName:selectItem.cnName, type:selectItem.remark };
          modifierList.push(obj)
      }
      if (multiSpecListspecIds.length) {
        multiSpecListspecIds.forEach((ele) => {
          let obj = {
            specId: ele,
            specName: this.dicList.specList.find((sor) => sor.id == ele).cnName,
          };
          multiSpecList.push(obj);
        });
      }
      let layoutName = "";
      if (this.type == "dwg") {
        layoutName = JSON.parse(this.spaceOfDwgData);
      } else if (this.type == "rvt") {
      }
      let annexFileList = [];
      if (!!this.floderData && this.floderData.length) {
        this.floderData.forEach((ele) => {
          let obj = {
            fileId: ele.fileId,
            fileName: ele.fileName,
            id: "",
            uploadType: ele.uploadType,
          };
          annexFileList.push(obj);
        });
      }
      let newcoordinatedata = "";
      if (this.qmData.coordinate) {
        let newcoordinate = JSON.parse(this.qmData.coordinate);
        if (newcoordinate.stMarkNewInfo) {
          newcoordinate.stMarkNewInfo.strText = checkContent;
        }
        newcoordinatedata = JSON.stringify(newcoordinate);
      }
      const params = {
        questionId: this.questionId,
        prjId: this.prjID,
        fileList: this.fileList,
        checkContent,
        qmTypeId,
        qmType,
        problemTypeId,
        problemType,
        coordinate: newcoordinatedata,
        // modifierId,
        // modifierName,
        modifierList,
        drawingReviewPoints,
        source,
        multiSpecList,
        // stageId,
        // stageName,
        specId,
        specName,
        // stageChildId,
        // stageChildName,
        layoutName, //布局空间,
        picMd5List: this.picList,
        autoScreenshotMd5: this.qmData.autoScreenshotMd5,
        annexFileList,
      };
      return params;
    },
  },
  watch: {
    floderObj(newValue) {
      if (newValue.fileId) {
        this.floderData.push(newValue);
      } else {
        this.floderData = [];
      }
    },
  },
  methods: {
    async init() {
      this.loading = true;
      if (this.type == "dwg") {
        this.prjID = JSON.parse(this.dwgdata).prjID;
        this.fileId = JSON.parse(this.dwgdata).fileId;
      } else if (this.type == "rvt") {
        if (!!this.modeldata.fileObj) {
          this.fileId = "";
          this.prjID = this.modeldata.prjId;
        } else {
          this.fileId = this.modeldata.fileId;
          this.prjID = this.modeldata.prjId;
        }
      } else {
        this.fileId = this.$route.query.f;
        this.prjID = this.$route.query.prjId;
      }
      await this.queryDic();
      this.$nextTick(async () => {
        await this.getList();
      });
    },
    async queryDic() {
      const res = await question.getNotationDic(this.prjID, this.fileId);
      this.dicList = res.data || {};
      let roleList = { label: '角色', options: res.data.roleList };
      let userList = { label: '用户', options: res.data.userList };
      this.dicList.modifierList = [roleList, userList]
    },
    async getList() {
      try {
        const res = await notationService.getDrawingQuestionDetails(
          this.questionId
        );
        this.qmData = res.data;
        console.log(this.qmData);
        this.floderData = [];
        if (!!res.data.annexFileList && res.data.annexFileList.length) {
          this.floderData = res.data.annexFileList;
        }
        this.addForm.checkContent = this.qmData.checkContent;
        this.addForm.drawingReviewPoints = this.qmData.drawingReviewPoints;
        this.addForm.qmTypeId = this.qmData.qmTypeId;
        this.addForm.problemTypeId = this.qmData.problemTypeId;
        this.addForm.specId = this.qmData.specId;
        this.addForm.modifierIds = this.qmData.modifierList?.[0]?.modifierId;
        if (this.qmData.multiSpecList) {
          let list = this.dicList.specList.filter(
            (ele) => ele.id != this.qmData.specId
          );
          let ids = [];
          this.qmData.multiSpecList.forEach((item) => {
            let id = list.find((ele) => ele.cnName == item.specName).id;
            ids.push(id);
          });
          console.log(ids);
          this.addForm.multiSpecListspecIds = ids;
        }

        if (!!this.qmData.picMd5List) {
          this.base64List.forEach(async (ele, index) => {
            if (!!this.qmData.picMd5List[index]) {
              ele.url = await this.toBase64(
                questionImgUrl1(this.qmData.picMd5List[index])
              );
              ele.hasKss = true;
            } else {
              ele.url = iconImage;
              ele.hasKss = false;
            }
          });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    //取消修改
    closeModelq() {
      this.$emit("openList");
    },
    //确认修改
    addnotations() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          this.addLoading = true;
          this.picList = [];
          for (let index in this.base64List) {
            if (this.base64List[index].hasKss) {
              this.picList.push(
                await this.getFileMD5(this.base64List[index].url)
              );
            }
          }
          try {
            await notationService.notationEdit(this.editParams);
            this.$message.success("编辑成功");
            this.base64List.forEach((ele) => {
              ele.url = this.iconImage;
              ele.hasKss = false;
            });
            console.log(111);
            this.addForm = addParamsForm();
            this.addLoading = false;
            this.$emit("openList");
          } catch (error) {
            console.log(error);
            this.addLoading = false;
          }
        }
      });
    },
    toBase64(imgUrl) {
      // 一定要设置为let，不然图片不显示
      const image = new Image();
      // 解决跨域问题
      image.setAttribute("crossOrigin", "anonymous");
      const imageUrl = imgUrl;
      image.src = imageUrl;
      return new Promise((res) => {
        image.onload = () => {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          let quality = 0.8;
          const dataurl = canvas.toDataURL("image/jpeg", quality);
          res(dataurl);
        };
      });
      // image.onload为异步加载
    },
    async getFileMD5(base64) {
      const blob = this.dataURItoBlob(base64);
      const formData = new FormData();
      formData.set("files", blob);
      let res = await notationService.picupload(formData);
      if (res.result === "0") {
        return res.data[0];
      }
    },
    dataURItoBlob(base64Data) {
      let byteString;
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64Data.split(",")[1]);
      } else {
        byteString = unescape(base64Data.split(",")[1]);
      }
      let mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      let ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      let blob = new Blob([ia], { type: mimeString });
      return blob;
    },
    deleteImage(index) {
      this.base64List[index].url = iconImage;
      this.base64List[index].hasKss = false;
    },
    mouseenter(index) {
      this.imageIndex = index;
      this.showDelete = true;
    },
    mouseleave(index) {
      this.imageIndex = index;
      this.showDelete = false;
    },
    startKss(index, event) {
      //图纸截图
      if (this.type == "dwg") {
        let cutpic = "";
        Monge.Map.screenCapture(1, (canvas) => {
          let kss = new Kscreenshot({
            endCB: (imgs) => {
              cutpic = imgs;
              this.getAddCutPicList(cutpic, index);
            },
          });
          kss.startScreenShot(canvas);
        });
      } else if (this.type == "rvt") {
        let cutpic = "";
        Monge.Model.screenCapture(1, (canvas) => {
          let kss = new Kscreenshot({
            endCB: (imgs) => {
              cutpic = imgs;
              this.getAddCutPicList(cutpic, index);
            },
          });
          kss.startScreenShot(canvas);
        });
      } else {
        this.$emit("startKss", index, event);
      }
    },
    getAddCutPicList(cutimglist, index) {
      this.base64List[index].url = cutimglist;
      this.base64List[index].hasKss = true;
    },
    questionImgListUrl(fileMD5) {
      if (!fileMD5) {
        return;
      }
      return questionImgUrl1(fileMD5);
    },
    showImgPoint() {
      this.imgPoint = true;
      this.$nextTick(() => {
        this.$refs.checkImgPoint.showDialog();
        this.$refs.checkImgPoint.getAlldata();
      });
    },
    //  获取点击的审图要点数据
    getPointInfo(val) {
      this.addForm.drawingReviewPoints = val.mainPoint || "";
      this.imgPoint = false;
    },
    showAssociatedFile() {
      this.associatedFileShow = true;
      this.$nextTick(() => {
        this.$refs.associatedFile.showDialog();
      });
    },
    // 关联文档数据
    getAssociatedFile(val) {
      this.associatedFileShow = false;
      let arr1 = val;
      let arr2 = this.floderData;
      let arr1fileNames = new Set(arr1.map(({ fileName }) => fileName));
      let isfloderData = [
        ...arr1,
        ...arr2.filter(({ fileName }) => !arr1fileNames.has(fileName)),
      ];
      let isnotfloderData = [
        ...arr2.filter(({ fileName }) => arr1fileNames.has(fileName)),
      ];
      this.floderData = isfloderData;
      for (let key in isnotfloderData) {
        setTimeout(() => {
          this.$message.warning(
            `文件${isnotfloderData[key].fileName}上传失败，已存在同名文件`
          );
        }, 10);
      }
    },
    // 本地上传
    uploadFiles() {
      this.$store.dispatch("annotationUploadFloderData", this.floderData);
      this.$store.dispatch("annotationUploadType", new Date().getTime());
    },
    todown(row) {
      const prjId = this.$route.query.prjId;
      const fileId = row.fileId;
      const fileUrl = downloadUrltoken(prjId, fileId);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.height = 0;
      iframe.src = fileUrl;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    todel(index) {
      const obj = {};
      this.floderData = this.floderData.reduce((cur, next) => {
        obj[next.fileId] ? "" : (obj[next.fileId] = true && cur.push(next));
        return cur;
      }, []); // 设置cur默认类型为数组，并且初始值为空的数组
      this.floderData.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.edit {
  width: 100%;
  // height: 100%;
  padding: 10px 0 10px 10px;
  .editContent {
    width: 100%;
    height: calc(100% - 50px);
    padding-right: 10px;
    overflow-y: auto;
    .formStyle {
      padding-top: 10px;
    }
    .itemStyle {
      width: 100%;
      /deep/.el-form-item__label {
        width: 100% !important;
        display: flex;
      }
      /deep/.el-form-item__content {
        margin-top: 30px;
      }
    }
    .associatedFileStyle {
      width: 100%;
      /deep/.el-form-item__label {
        width: 100% !important;
        display: flex;
      }
      /deep/.el-form-item__content {
        margin-top: 30px;
      }
      li {
        display: flex;
        justify-content: space-between;
        color: #3873fe;
        cursor: pointer;
        border: 1px solid #ffffff00;
        .fileNamestyle {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 200px;
          padding-left: 5px;
        }
      }
      li:hover {
        background: #eef1ff;
      }
    }
    .labelStyle {
      font-size: 14px;
      line-height: 28px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 10px;
      margin-left: 20px;
      > span {
        font-size: 14px;
        line-height: 28px;
        margin-right: 10px;
      }
    }
    /deep/.el-radio {
      margin-right: 8px;
    }
    /deep/.el-select {
      width: 100%;
    }
  }
  .footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    .el-button {
      margin: 0 20px;
    }
  }
  .MQcut {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    .uploadpic {
      width: 75px;
      height: 75px;
      margin-right: 5px;
      position: relative;
      img {
        width: 75px;
        height: 75px;
      }
      .delete {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        z-index: 1px;
        cursor: pointer;
        i {
          font-size: 20px;
          color: #fff;
        }
      }
    }
    .canEdit {
      cursor: pointer;
    }
  }
}
</style>